<template>
  <div class="pageBawShop"
    @touchstart="touchEvent" 
    @touchmove="touchEvent" 
    @touchend="touchEvent" 
    @scroll="touchEvent"> 
    <mu-appbar class="XR-head" title="BAW">
      <mu-icon-button v-on:click="GoBack" icon=":fa fa-angle-left" slot="left"/>
      <mu-icon-menu icon=":fa fa-mymore" slot="right">
        <mu-menu-item to="/usercenter/index" title="个人中心"/>
        <mu-menu-item to="/" title="首页"/>
        <mu-menu-item to="/retail/cart" title="购物车"/>
      </mu-icon-menu>
    </mu-appbar>  

    <div class="bannerDiv">
      <router-link :to="bannerAd.AdLink"><img :src="bannerAd.AdImg" class="banner"></router-link>
    </div>
    <ul class="ph-nav clearfix">
        <li>
            <router-link to="/UserCenter/Baw" title="BAW记录">
                <div class="font one"> </div>
                <!-- <i class="fa fa-log"></i> -->
                <em>BAW记录</em>
            </router-link>
        </li>
        <li>
            <div @click="toBeOnline" title="赚取BAW" >
              <div class="font two"> <i class="fa fa-sellservice" style="font-size:20px;padding-left: 2px;"></i></div>
                <em>赚取BAW</em>
            </div>
        </li>
        <li>
            <div @click="toBeOnline" title="BAW帮助">
                <div class="font three"> <i class="fa fa-mycicle1" style="font-size:20px;"></i></div>
                <em>BAW帮助</em>
            </div>
        </li>
        <li>
            <router-link to="/UserCenter/candyOrderList" title="我的兑换">
               <div class="font four"> <i class="fa fa-receive"></i></div>
                <em>我的兑换</em>
            </router-link>
        </li>
      </ul>

    <ul class="ad-list">                                
      <li><router-link :to="AdLeft.AdLink"><img :src="AdLeft.AdImg"></router-link></li>                          
      <li><router-link :to="AdRight.AdLink"><img :src="AdRight.AdImg"></router-link></li>      
    </ul>
	<XR-load-more  :onLoadMore="onLoadMore" :enableLoadMore="enableLoadMore" ref="XRLoadMore">
    <div class="pro-list">
      <div :class="'item'+ (index%2==0?' rigthmargin':'') " v-for="(productItem,index) in integralProductList" :key="productItem.ProductId">
        <template v-if="productItem.SaleType == 1">          
          <div class="top">
            <router-link :to="'/retail/ProductDetail?skuId='+ productItem.SkuId"><img :style="{height: imgHeight+'px'}" :src="productItem.DefaultImage?productItem.DefaultImage: IMGServer_URL+'/images/index-item-default.png'" class="pro-img"></router-link>
            <!-- <div class="dk">
              <span>可抵</span>
              <span>{{productItem.BawPrice}}元</span>
            </div> -->
          </div>
          <div class="text">
            <div class="money">
              <p class="price">￥<span>{{productItem.SalePrice.toFixed(2)}}</span></p>
              <p class="del-price">￥{{productItem.Price.toFixed(2)}}</p>
            </div>
            <router-link :to="'/retail/ProductDetail?skuId='+ productItem.SkuId"><p class="name">{{productItem.ProductName}}</p></router-link>
            <p class="buycount">{{productItem.SaleCount}}人已购买</p>
          </div>
        </template>
        <template v-else>
          <div class="top">
            <router-link :to="'/baw/ProductDetail?skuId='+ productItem.SkuId"><img :style="{height: imgHeight+'px'}" :src="productItem.DefaultImage?productItem.DefaultImage: IMGServer_URL+'/images/index-item-default.png'" class="pro-img"></router-link>
            <!-- <div class="dk">
              <span>全额</span>
              <span>抵扣</span>
            </div> -->
          </div>
          <div class="text">
            <div class="money">
              <p class="price">BAW<span>{{productItem.SalePrice.toFixed(2)}}</span></p>
              <p class="del-price">￥{{productItem.Price.toFixed(2)}}</p>
            </div>
            <router-link :to="'/baw/ProductDetail?skuId='+ productItem.SkuId"><p class="name">{{productItem.ProductName}}</p></router-link>
            <p class="buycount">{{productItem.SaleCount}}人已购买</p>
          </div>
        </template>
      </div>
      <div v-if="isShowLastDefault" class="item" :style="{width:itemWidth+'px', marginBottom:0}">
        <img src="/static/index/index-item-default.png" style="display:block;" />
      </div>
    </div>
	</XR-load-more>

    <XR-toast ref="XRtoast"></XR-toast>
    <XR-signin ref="XRsigin" @onClose="readSignInfo"></XR-signin>
  </div>
</template>

<script>
export default {
  data(){
    return {
      integralProductList:[],
      bannerAd:{},
      AdLeft:{},
      AdRight:{},
      NowSignInfo:{},
      itemWidth: document.documentElement.clientWidth * 0.49,
      TomorrowSignInfo:{},
      memberFinance:{},
      sWidth : document.documentElement.clientWidth,
      isLogin:false,
      imgHeight: 0,
      isShowLastDefault:false,
	  page:1,
      pageSize:10,
      totalPage:0,
      enableLoadMore: true,
    }
  },
  mounted(){
    this.$postBase(
      this.MOBILE_URL + "/Oauth2/WeChat/wechat.ashx"
      ).then(function(res) {
      if(!res.IsSuccess){
          //ths.$refs.XRtoast.failed(res.Msg, true)
      }else{
          wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: res.Data.AppId, // 必填，公众号的唯一标识
              timestamp: res.Data.TimeStamp, // 必填，生成签名的时间戳
              nonceStr: res.Data.NonceStr, // 必填，生成签名的随机串
              signature: res.Data.Sign, // 必填，签名，见附录1
              jsApiList: [] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
          wx.ready(function () {
              WeixinJSBridge.call('hideOptionMenu');
          });
      }
    });
    this.getBawProductList()
    this.getIntegralAdList()

    if (this.$store.state.user.SessionId) {
      this.isLogin =true
      this.readSignInfo()
    }
    this.imgHeight = this.sWidth*0.49  
  },
  methods:{    
    GoBack(){
      var auth = this.$store.state.baw.BtnAuth
      if(auth && auth.indexOf('back')>=0){        
        var appClient = window.localStorage.appClient
        if(appClient){
          if(appClient == 'ios'){
            window.webkit.messageHandlers.ajax.postMessage({fun:'back'})
          }else{
            ajax.back()
          }
        }else{
          this.$router.goBack()
        }      
      }
      else{
        this.$router.goBack()
      }
    },
    touchEvent (){
        var scrollTop = this.$el.scrollTop
        var imgHeigth= document.querySelector('.bannerDiv').offsetHeight+65 
        var opacityValue=this.$el.scrollTop/imgHeigth
        document.querySelector('.mu-appbar').style.background='rgba('+this.themeColor+','+opacityValue+')'
    }, 
    pencil(){
      this.$el.querySelector('.bannerDiv a').classList.add("pencil");
    },
    getIntegralAdList(){
      const ths = this;
      this.$post("/Shop/AdServer/GetAdsByPage",{ClientType:2, pageId:'c741b55d87384efdb268a78900f91171'})
      .then(function(res) {
        if (res.IsSuccess) {
          ths.loaded = false
          
          for(var i = 0; i< res.Data.length;i++){
            if(res.Data[i].AdName == '积分商城banner广告'){
              ths.bannerAd = res.Data[i];
            }
            else if(res.Data[i].AdName == '积分商城横幅广告（左）'){
              ths.AdLeft = res.Data[i];
            }
            else if(res.Data[i].AdName == '积分商城横幅广告（右）'){
              ths.AdRight = res.Data[i];
            }
          }

          ths.$refs.XRtoast.hide()
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    getBawProductList(isNew){
      const ths = this;
      this.$post("/Shop/BawServer/GetBawProductList", {pageIndex: this.page, pageSize: ths.pageSize})
      .then(function(res) {
        if (res.IsSuccess) {
          ths.loaded = false

          if(isNew){
            ths.integralProductList = res.Data.List
          }else{
            for(var i = 0; i < res.Data.List.length;i++){
              ths.integralProductList.push(res.Data.List[i])
            }
          }
          ths.totalPage = res.Data.Rows % ths.pageSize ==0?res.Data.Rows / ths.pageSize:res.Data.Rows / ths.pageSize+1
          if(ths.page >= ths.totalPage){
            this.enableLoadMore = false
          }
          ths.isShowLastDefault = ths.integralProductList.length % 2==1?true:false
          ths.$refs.XRtoast.hide()
        }else{          
          ths.enableLoadMore = false
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    getSignInfo(){
      const ths = this;
      this.$post("/Shop/UserServer/GetSigninGiveDayInfo")
      .then(function(res) {
        if (res.IsSuccess) {
          ths.loaded = false
          ths.$refs.XRtoast.hide()
          
          var signDate = new Date()
          var year = signDate.getFullYear()
          var month = (signDate.getMonth()+1)
          if(month <10){
            month = '0'+ month
          }
          var day = signDate.getDate()
          if(day <10){
            day = '0'+ day
          }
          var signDateString = year+"-"+month+"-"+day
          for(var i = 0; i < res.Data.itemlist.length;i++){
            var signItem = res.Data.itemlist[i]
            var tmpDate = signItem.date.split('T')[0]
            if(signDateString == tmpDate){
              ths.NowSignInfo = signItem
              break;
            }
          }
          ths.TomorrowSignInfo = res.Data.tomorrowitem
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },    
    getFinanceInfo: function() {
      var ths = this;
      this.$post(
        "/Shop/UserServer/GetMemberFinanceAccount"
      ).then(function(res) {
        ths.memberFinance = res.Data;
      });
    },
    toBeOnline:function(){
      this.$refs.XRtoast.load('拼命开发中...',true);
    },
    signin(){
      this.$refs.XRsigin.show()
    },
    readSignInfo(){
      this.getSignInfo()
      this.getFinanceInfo()
    },
    onLoadMore(done) {
      setTimeout(()=>{
          if(!this.enableLoadMore) {
              return
          }
          if(this.page >= this.totalPage){
            this.enableLoadMore = false
            return
          }
          this.page = this.page + 1
          this.getBawProductList(false);
          done();
      }, 200)
    },
  }
}
</script>

<style>
.pageBawShop .XR-head{
  position: fixed;
  background: rgb(0,0,0,0);
  box-shadow: none;
}
.pageBawShop .banner
{
    width:100%;    
    display:block;
}
.pageBawShop .bannerDiv a{
  height: 146px;
  width: 100%;
}
.pageBawShop .bannerDiv a::before{
  content: "";
  position: absolute;
  width: 140px;
  height: 146px;
  top: 0;
  left: -10px;
  overflow: hidden;
  transform: skewX(-40deg);
  z-index: 10;
  background: -webkit-linear-gradient(left, rgba(255,255,255,0)0, rgba(255,255,255,0.2)50%, rgba(255,255,255,0)100%);
}
.pageBawShop .bannerDiv a::before {
  animation: pencil 4s infinite;
	-webkit-animation: pencil 4s infinite;
  transition: left 0.5s ease 0s; 
}
@keyframes pencil
{
	0% {left: -10;}
  100% {left: 150%; }
}
@-webkit-keyframes pencil /* Safari and Chrome */
{
	0% {left: -10;}
  100% {left: 150%; }
}
.pageBawShop .ph-nav{
  padding:.8rem 0;
  background:white;
  overflow: hidden;
}
.pageBawShop .ph-nav li{
  float:left;
  width:25%;
  list-style: none;
}
.pageBawShop .ph-nav li .font{
  text-align: center;
  width: 40px;
  height: 40px;
  line-height: 45px;
  margin: 0px auto;

}
.pageBawShop .ph-nav li .font.one{
  background: url('/static/BAW/member.png');
  background-size: 100% 100%;
  transition: 1s;
  transform: scale(0.8);
  animation: myfirst 1s infinite;
	-webkit-animation: myfirst 1s infinite;
  animation-direction:alternate-reverse;
}
@keyframes myfirst
{
	0% {transform: scale(0.8);}
  50% {transform: scale(0.9);}
  100% {transform: scale(1);}
}
@-webkit-keyframes myfirst /* Safari and Chrome */
{
	0% {transform: scale(0.8);}
  50% {transform: scale(0.9);}
  100% {transform: scale(1);}
}
.pageBawShop .ph-nav li .font.two{
  background: url('/static/BAW/zhuanqu.png');
  background-size: 100% 100%;
}
.pageBawShop .ph-nav li .font.three{
  background: url('/static/BAW/bangzhu.png');
  background-size: 100% 100%;
}
.pageBawShop .ph-nav li .font.four{
  background: url('/static/BAW/duihuan.png');
  background-size: 100% 100%;
  transform: scale(0.8);
  animation: myfirst 1s infinite;
	-webkit-animation: myfirst 1s infinite;
  animation-direction:alternate-reverse;
}
@keyframes myfirst
{
	from {transform: scale(0.8);}
	to {transform: scale(1);}
}
@-webkit-keyframes myfirst /* Safari and Chrome */
{
	from {transform: scale(0.8);}
	to {transform: scale(1);}
}
.pageBawShop .ph-nav li .font .fa{
  font-size: 18px;
  color: #fff;
}
.pageBawShop .ph-nav li img{ width:30%; padding:0; margin:0; display:block; margin:0 auto;}
.pageBawShop .ph-nav li em{
  font-size: .75rem;
  line-height: 1.0rem;
  color: #5A5655;
  display:block;
  text-align:center;
  font-style: normal;
  margin-top: 5px;
}
.pageBawShop .ad-list { overflow:hidden; margin-bottom:0.2rem;}
.pageBawShop .ad-list li { float:left; width:50%; list-style: none;}
.pageBawShop .ad-list li img { width:100%; display:block;}

.pageBawShop .pro-list { background:#EEEDEE;}
.pro-list .item { width:49%; float:left; margin-bottom:5px; background:white;}
.pageBawShop .pro-list .item.rigthmargin { margin-right:2%;}
.pageBawShop .pro-list .item .top { position:relative;}
.pageBawShop .pro-list .item .top img { width:100%; display:block;}
.pageBawShop .pro-list .item .top .dk { position:absolute; top:4px; right:4px; color:red;   text-align:center;}
.pageBawShop .pro-list .item .top .dk span { font-size:12px; display:block; height:14px; line-height:14px; font-weight:700;}
.pageBawShop .pro-list .text { padding:0 5px;}
.pageBawShop .pro-list .text .money { font-size:12px; overflow:hidden; margin:5px 0;} 
.pageBawShop .pro-list .text .money .price { float:left;color:Red;  padding-left:5px; line-height:1.0rem;}
.pageBawShop .pro-list .text .money .price span { font-size:16px; font-weight:700;}
.pageBawShop .pro-list .text .money .del-price { float:left; color:#A0A0A0; text-decoration:line-through; margin-left:10px; line-height:18px;}
.pageBawShop .pro-list .item .name { 
  color: #000;  
  width:100%; 
  overflow:hidden; 
  height:36px; 
  line-height:18px; 
  font-size:14px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.pageBawShop .pro-list .item .buycount { margin:5px 0; width:100%; overflow:hidden; height:16px; text-align:right; color:#999; line-height:16px; font-size:12px;}

      
.pageBawShop .signin { height:70px; background:#F9CC9D; overflow:hidden;}
.pageBawShop .signin .left { float:left;margin-left:5px;}
.pageBawShop .signin .left .box-open { float:left; margin-top:6px; width:55px;}
.pageBawShop .signin .left .info { float:left; margin-top:21px; margin-left:4px;}
.pageBawShop .signin .left .info .desc { font-size:12px; overflow:hidden; }
.pageBawShop .signin .left .info .desc .special { font-size:16px;line-height:16px; color:#FF0000; float:left;}
.pageBawShop .signin .left .info .desc .normal { font-size:12px; line-height:14px; margin-left:5px; float:left;}
.pageBawShop .signin .left .info .tip { font-size:12px; line-height:12px; margin-top:3px;}
.pageBawShop .signin .right { float:right; margin-right:5px;}
.pageBawShop .signin .right .signin-btn { float:left; margin-top:14px; width:46px;}
.pageBawShop .signin .right .btn { float:left; margin-top:22px;margin-left:2px;}
.pageBawShop .signin .right .btn .btn-text { font-size:12px;line-height:12px;}
.pageBawShop .signin .right .btn .award { font-size:12px;line-height:12px; margin-top:6px;}  
.pageBawShop .XR-head .left .mu-icon-button .fa-angle-left {
    background: rgba(71,74,79,0.25);
    border-radius: 50%;
}
.pageBawShop .XR-head .mu-appbar-title span {
    color: #fff;
}
.pageBawShop .mu-appbar .right .mu-icon-button>div {
    background: rgba(71, 74, 79, 0.3);
    border-radius: 50%;
    width: 24px;
    height: 24px;
    text-align: center;
}
.pageBawShop .mu-appbar .right .mu-icon-button .fa-mymore{
  font-size: 16px;
}

</style>



// WEBPACK FOOTER //
// src/pages/baw/index.vue